module["exports"] = ["+43-6##-#######", "06##-########", "+436#########", "06##########"];